'use client';

import { useEffect, useState } from 'react';
import { format } from 'timeago.js';
import dayjs from 'dayjs';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import useInterval from 'src/hooks/useInterval';
import { STANDARD_DATE_FORMAT } from 'src/constants/dates';

interface RelativeDateDisplayProps {
	date: Date;
	displayAsTimestamp: boolean;
}

export function RelativeDateDisplay({
	date,
	displayAsTimestamp,
}: RelativeDateDisplayProps) {
	const [timeAgoString, setTimeAgoString] = useState(() => format(date));

	const dateTime = date.getTime();
	useEffect(() => {
		setTimeAgoString(format(date));
	}, [dateTime]);

	useInterval(() => {
		setTimeAgoString(format(date));
	}, 10000);

	const absoluteTime = dayjs(date).format(`${STANDARD_DATE_FORMAT} h:mm:ss A`);

	if (displayAsTimestamp) {
		return (
			<div className="flex flex-col">
				<span>{dayjs(date).format(STANDARD_DATE_FORMAT)}</span>
				<span>{dayjs(date).format('h:mm:ss A')}</span>
			</div>
		);
	}

	return (
		<Tooltip decoration="none" content={absoluteTime}>
			<span>{timeAgoString}</span>
		</Tooltip>
	);
}
